import React from "react";
import { Map } from "lucide-react";
import RepTerritoryView from "@/components/RepTerritoryView";
import { isRepUser, repOf } from "@/components/RepField";

const RepTerritoryPage = ({ user, initialRep = null }) => (
  <div className="p-4 lg:p-6 space-y-4" data-testid="rep-territory-page">
    <div>
      <h1
        className="text-lg sm:text-xl lg:text-2xl font-bold flex items-center gap-2"
        style={{ fontFamily: "Manrope, sans-serif" }}
      >
        <Map className="w-5 h-5 text-primary" />
        {isRepUser(user) ? "My Territory" : "Territory"}
      </h1>
      <p className="text-xs sm:text-sm text-muted-foreground mt-1">
        {isRepUser(user)
          ? `${repOf(user)} — who still needs a visit, and the quickest way round them`
          : "Pick a rep to see their territory, coverage gaps and best route"}
      </p>
    </div>
    <RepTerritoryView user={user} initialRep={initialRep} />
  </div>
);

export default RepTerritoryPage;
